// extracted by mini-css-extract-plugin
export default {"container":"LockedRutInput_container__UI00I","icon":"LockedRutInput_icon__E01c5","label":"LockedRutInput_label__7oOOH","rut":"LockedRutInput_rut__TNy38"};